const CHUNK_RELOAD_PREFIX = 'rely:chunk-reload:';

const isChunkLoadError = (error) => {
  const message = error?.message || '';
  const name = error?.name || '';

  return (
    name === 'ChunkLoadError' ||
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    message.includes('Failed to fetch dynamically imported module')
  );
};

export const lazyWithRetry = (importer, key = 'default') => {
  return async () => {
    try {
      const module = await importer();
      sessionStorage.removeItem(`${CHUNK_RELOAD_PREFIX}${key}`);
      return module;
    } catch (error) {
      const reloadKey = `${CHUNK_RELOAD_PREFIX}${key}`;
      const hasRetried = sessionStorage.getItem(reloadKey) === '1';

      if (isChunkLoadError(error) && !hasRetried) {
        sessionStorage.setItem(reloadKey, '1');
        window.location.reload();
        return new Promise(() => {});
      }

      sessionStorage.removeItem(reloadKey);
      throw error;
    }
  };
};

export const __internal = {
  isChunkLoadError,
  CHUNK_RELOAD_PREFIX,
};
